import { styled } from '@mui/material/styles'
import { ListItemText, Box } from '@mui/material'

export const TextWrapper = styled(Box)(`
    display:flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width:100%;
`)

export const Text = styled(ListItemText)(({ theme }) => `
    width:calc(33% - 5px);
    flex:none;
    & span {font-size: 14px; font-weight:500; color:${theme.components.MuiParagraph.styleOverrides.color};}
    & p {font-size: 14px; font-weight:400; color:${theme.components.MuiParagraph.styleOverrides.color};}
`)
